import Vue from 'vue';
import Router from 'vue-router';
import Signin from '@/components/Signin';
import Home from '@/components/Home';
import Invoices from '@/components/Invoices';
import InvoicePreview from '@/components/InvoicePreview';
import Clients from '@/components/Clients';
import SalesBookPreview from '@/components/SalesBookPreview';
import Settings from '@/components/Settings';
import { auth } from '../services/firebase';

Vue.use(Router);

let router = new Router({
	routes: [
		{
			path: '/signin',
			name: 'Signin',
			component: Signin,
			meta: {
				public: true
			}
		},
		{
			path: '/',
			name: 'Home',
			component: Home
		},
		{
			path: '/invoices',
			name: 'Invoices',
			component: Invoices
		},
		{
			path: '/invoices/:id',
			name: 'InvoicePreview',
			component: InvoicePreview
		},
		{
			path: '/clients',
			name: 'Clients',
			component: Clients
		},
		{
			path: '/sales/:year',
			name: 'SalesBookPreview',
			component: SalesBookPreview
		},
		{
			path: '/settings',
			name: 'Settings',
			component: Settings
		},
		{
			path: '*',
			redirect: '/signin'
		}
	],
	linkActiveClass: 'active',
	linkExactActiveClass: 'active',
	mode: 'history'
});

router.beforeEach((to, from, next) => {
	let currentUser = auth.currentUser;
	let requiresAuth = !to.matched.every(record => record.meta.public);

	if (requiresAuth && !currentUser)
		next('/signin');
	else if (!requiresAuth && currentUser)
		next('/');
	else
		next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js